import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CertificationCategory } from '../../models/certificationCategory';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificationCategoryService {

  constructor(private http: HttpClient) { }

  list(): Observable<Array<CertificationCategory>> {
    return this.http.get<Array<CertificationCategory>>(`${environment.baseApiUrl}/certification_categories/`)
      .pipe(map((res: any) => res.map((d: any) => new CertificationCategory(d))));
  }
}
